package dev.terrakok.mapitan

import androidx.compose.foundation.gestures.drag
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.input.pointer.AwaitPointerEventScope
import androidx.compose.ui.input.pointer.PointerInputChange
import androidx.compose.ui.unit.Density
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.DpOffset
import androidx.compose.ui.unit.DpRect
import org.maplibre.compose.map.MapState
import org.maplibre.spatialk.geojson.Position

internal expect fun platformMapScrollUnits(value: Float, density: Density): Float

internal suspend fun AwaitPointerEventScope.dragAnchoredPoint(
    density: Density,
    down: PointerInputChange,
    mapState: MapState,
    anchor: Position,
    onDrag: (Position) -> Unit,
    onTap: () -> Unit,
    onFinish: () -> Unit,
    onCancel: () -> Unit,
) {
    val grab = down.position - with(density) { toOffset(mapState.screenLocationFromPosition(anchor) ?: DpOffset.Zero) }
    down.consume()

    var dragged = false
    val completed = try {
        drag(down.id) { change ->
            change.consume()
            if (!dragged &&
                (change.position - down.position).getDistance() < viewConfiguration.touchSlop
            ) return@drag
            val position = mapState.positionFromScreenLocation(
                with(density) { toDpOffset(change.position - grab) }
            ) ?: return@drag
            dragged = true
            onDrag(position)
        }
    } catch (error: Throwable) {
        onCancel()
        throw error
    }

    when {
        !completed -> onCancel()
        dragged -> onFinish()
        else -> onTap()
    }
}

private fun Density.toDpOffset(offset: Offset): DpOffset = DpOffset(offset.x.toDp(), offset.y.toDp())
private fun Density.toOffset(dpOffset: DpOffset): Offset = Offset(dpOffset.x.toPx(), dpOffset.y.toPx())
internal fun DpOffset.toExpandedRect(radius: Dp): DpRect = DpRect(x - radius, y - radius, x + radius, y + radius)
